module.exports = __webpack_public_path__ + "static/media/loades-eco-park-may.c2319174.jpg";